<template>
  <dialog_wheelDateChooser 
    @submit="handleDateSubmit" 
    v-if="datePickerShow" 
    :default-date="tempDateForWheel" 
  />

  <dialog_customerPicker  @submit="handleCustomerPickerSubmit"  v-if="showCustomerPicker"  />
  <dialog_customerTagEdit v-if="tag_edit_show" :tagEditSwitch="tagEditSwitch" :reloadTagList="reloadTagList" />

  <div id="dialog-customerEdit">
    <div class="dialog">
      <span class="cls" @click="editDialogSwitch(false)"></span>


      <div class="paper" v-if="editingPart == 'basic'">
        <div class="header"> 
          <h1>🙎‍♀️ 기본정보 수정</h1> 
          <span @click="editDialogSwitch(false)">X</span> 
        </div>

        <div class="content">
          
          <!-- 프로필 이미지 영역 추가 -->
          <div class="profile-image-section">
            <div class="profile-image-wrapper" @click="triggerProfileInput">
              <img 
                v-if="editingCustomer.image" 
                :src="editingCustomer.image" 
                alt="프로필"
                class="profile-image"
              />
              <div v-else class="profile-placeholder">
                <i class="ph ph-user"></i>
              </div>
              <div class="profile-overlay">
                <i class="ph ph-camera"></i>
              </div>
              <div class="uploading-indicator" v-if="isUploadingProfile">
                <i class="ph ph-spinner"></i>
              </div>
            </div>
            <input 
              type="file" 
              ref="profileInput" 
              @change="handleProfileSelect" 
              accept="image/*"
              style="display: none;"
            >
            <div class="profile-actions">
              <button type="button" class="profile-btn" @click="triggerProfileInput" :disabled="isUploadingProfile">
                <i class="ph ph-upload-simple"></i> 사진 변경
              </button>
              <button type="button" class="profile-btn delete" @click="removeProfileImage" v-if="editingCustomer.image" :disabled="isUploadingProfile">
                <i class="ph ph-trash"></i> 삭제
              </button>
            </div>
          </div>

          <div class="double">
            <div class="single">
              <label>성명*</label>
              <input type="text" v-model="editingCustomer.name">
            </div>
            <div class="single">
              <label>문자호칭</label>
              <input type="text" v-model="editingCustomer.title">
            </div>
          </div>

          <div class="single">
            <label>별칭</label>
            <input type="text" v-model="editingCustomer.nickname">
          </div>

          <div class="double">
            <div class="single">
              <label>주민번호 앞자리 6자</label>
              <input  type="text"  v-model="firstCivNum" placeholder="199912" maxLength="6" >
            </div>
            <div class="single">
              <label>주민등록번호 뒷자리 7자</label>
              <input 
                type="text" 
                v-model="lastCivNum" 
                placeholder="1234567"
                maxLength="7"
              >
            </div>
          </div>

          <div class="single">
            <label>실제생일</label>
            <input 
              type="text" 
              v-model="editingCustomer.birth" 
              @input="formatBirth"
              placeholder="YYYY-MM-DD (예: 1990-12-30)"
              maxlength="10"
            >
          </div>

          <div class="single">
            <label>연락처</label>
            <input type="text" v-model="editingCustomer.phone">
          </div>

          <div class="single">
            <label>주소</label>
            <input type="text" v-model="editingCustomer.address">
          </div>

          <div class="single">
            <label>상세주소</label>
            <input type="text" v-model="editingCustomer.ex_address">
          </div>

          <div class="single">
            <label>시군구</label>
            <input type="text" v-model="editingCustomer.location">
          </div>

          <div class="double">
            <div class="single">
              <label>키맨</label>
              <select v-model="editingCustomer.is_keyman">
                <option value="0">X</option>
                <option value="1">O</option>
              </select>
            </div>
            <div class="single">
              <label>VIP 등급</label>
              <select v-model="editingCustomer.vip_rank">
                <option value="0">없음</option>
                <option value="1">VIP</option>
                <option value="2">VVIP</option>
                <option value="3">VVVIP</option>
              </select>
            </div>
          </div>

          <div class="single">
            <label>관계선택</label>
            <select v-model="editingCustomer.m_type">
              <option value="X">X 지인</option>
              <option value="Y">Y 인맥</option>
              <option value="Z">Z 개척</option>
            </select>
          </div>

          <div class="single">
            <label>나와의 관계</label>
            <div class="custom-select-wrapper">
              <select v-model="relationToMeSelected" @change="onRelationToMeChange">
                <option value="">선택안함</option>
                <option v-for="(type, index) in relation_to_me_list" :key="index" :value="type">{{ type }}</option>
                <option value="__custom__">✏️ 직접 입력</option>
              </select>
              <input 
                v-if="relationToMeCustomMode" 
                type="text" 
                v-model="editingCustomer.relation_to_me" 
                placeholder="관계를 직접 입력하세요"
                class="custom-input"
              >
            </div>
          </div>

          <div class="single">
            <label>관리등급</label>
            <select v-model="editingCustomer.manage_rank">
              <option value="0">없음</option>
              <option value="1">PB (홍보)</option>
              <option value="2">PS (가망)</option>
              <option value="3">TA (연락)</option>
              <option value="4">AP (접근)</option>
              <option value="5">FF (설계)</option>
              <option value="6">PC (체결)</option>
              <option value="7">CS (관리)</option>
            </select>
          </div>

          <div class="single">
            <label>고객 그룹 <button @click="tagEditSwitch(true)">고객그룹 설정</button> </label>
            <div class="tag-container">
              <template  v-for="(tag, index) in myAllTags" :key="index">
                <span class="tag-item" :class="tagList.includes(tag.name) ? 'checked' : ''" @click="toggleTag(tag)"> {{ tag.name }} </span>
              </template>
            </div>
          </div>

        
          <!-- 여기부터 수신동의 추가 -->
          <div class="single">
            <label>수신동의</label>
            <div class="agreement-edit-list">
              <div class="agreement-edit-item" @click="toggleAgreement('privacy')">
                <div class="checkbox" :class="{ checked: editingCustomer.agree_privacy == 1 }">
                  <i class="ph-bold ph-check" v-if="editingCustomer.agree_privacy == 1"></i>
                </div>
                <div class="agreement-info">
                  <span class="label">개인정보 수집 및 이용 동의</span>
                  <span class="badge required">필수</span>
                </div>
                <span class="date" v-if="editingCustomer.agree_privacy_at">
                  {{ formatDate(editingCustomer.agree_privacy_at) }}
                </span>
              </div>

              <div class="agreement-edit-item" @click="toggleAgreement('sms')">
                <div class="checkbox" :class="{ checked: editingCustomer.agree_sms == 1 }">
                  <i class="ph-bold ph-check" v-if="editingCustomer.agree_sms == 1"></i>
                </div>
                <div class="agreement-info">
                  <span class="label">SMS 수신 동의</span>
                  <span class="badge optional">선택</span>
                </div>
                <span class="date" v-if="editingCustomer.agree_sms_at">
                  {{ formatDate(editingCustomer.agree_sms_at) }}
                </span>
              </div>

              <div class="agreement-edit-item" @click="toggleAgreement('email')">
                <div class="checkbox" :class="{ checked: editingCustomer.agree_email == 1 }">
                  <i class="ph-bold ph-check" v-if="editingCustomer.agree_email == 1"></i>
                </div>
                <div class="agreement-info">
                  <span class="label">이메일 수신 동의</span>
                  <span class="badge optional">선택</span>
                </div>
                <span class="date" v-if="editingCustomer.agree_email_at">
                  {{ formatDate(editingCustomer.agree_email_at) }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="btns">
          <button @click="editDialogSwitch(false)">취소</button>
          <button class="confirm" @click="saveCustomer">저장</button>
        </div>
      </div>


      <div class="paper" v-if="editingPart == 'job'">
        <div class="header"> 
          <h1>💼 직업정보 수정</h1> 
          <span @click="editDialogSwitch(false)">X</span> 
        </div>

        <div class="content">
          <div class="double">
            <div class="single">
              <label>직업</label>
              <input type="text" v-model="editingCustomer.job" placeholder="사무직">
            </div>
            <div class="single">
              <label>위험등급</label>
              <select type="text" v-model="editingCustomer.job_grade">
                <option value="1">1군 (안전)</option>
                <option value="2">2군 (저위험)</option>
                <option value="3">3군 (중위험)</option>
                <option value="4">4군 (고위험)</option>
                <option value="5">5군 (매우위험)</option>
              </select>
            </div>
          </div>
          <div class="single">
            <label>직장명</label>
            <input type="text" v-model="editingCustomer.job_name" placeholder="삼성전자 하청업체">
          </div>
          <div class="single">
            <label>부서</label>
            <input type="text" v-model="editingCustomer.job_dept" placeholder="총리부">
          </div>
          <div class="single">
            <label>직장주소</label>
            <input type="text" v-model="editingCustomer.job_adrs" placeholder="경기도 수원시 영통구 삼성로 129(매탄동)">
          </div>
          <div class="single">
            <label>직장연락처</label>
            <input type="text" v-model="editingCustomer.job_phone" placeholder="02-2255-0114">
          </div>
        </div>
        
        <div class="btns">
          <button @click="editDialogSwitch(false)">취소</button>
          <button class="confirm" @click="saveCustomer">저장</button>
        </div>
      </div>


      <div class="paper" v-if="editingPart == 'family'">
        <div class="header"> 
          <h1>👨‍👩‍👧‍👦 가족정보 수정</h1> 
          <span @click="editDialogSwitch(false)">X</span> 
        </div>

        <div class="content">
          <ul class="family-list">
            <li  v-for="(member, index) in relation_info" :key="index">
              <button @click="deleteRelation(member)" class="delete"><i class="ph-fill ph-minus-circle"></i></button>
              <span>{{member.linked_customer_name || '-'}} </span>
              <span>
                <div class="custom-select-wrapper">
                  <select v-model="member.relation_type" @change="onFamilyRelationChange(member, $event)">
                    <option value="">관계선택</option>
                    <option v-for="(type, index) in relation_type_list" :key="index" :value="type">{{ type }}</option>
                    <option value="__custom__">✏️ 직접 입력</option>
                  </select>
                  <input 
                    v-if="member._customMode" 
                    type="text" 
                    v-model="member.relation_type" 
                    @change="updateRelationType(member)"
                    placeholder="관계를 직접 입력"
                    class="custom-input"
                  >
                </div>
              </span>
              <span> {{member.linked_customer_rrn || '000000-0000000'}} </span>
            </li>
            <li>
              <button @click="customerPickerSwitch(true)" class="add"><i class="ph-fill ph-plus-circle"></i> <span>관계인 추가</span> </button>
            </li>
          </ul>
        </div>

        <div class="btns">
          <button @click="editDialogSwitch(false)">취소</button>
          <button class="confirm" @click="saveCustomer">저장</button>
        </div>
      </div>


      <div class="paper" v-if="editingPart == 'employment'">
        <div class="header"> 
          <h1>🩺 고지사항 (병력사항)</h1> 
          <span @click="editDialogSwitch(false)">X</span> 
        </div>

        <div class="content">
          <ul class="med-his-list">
            <li v-for="(med_his, i) in med_history_list" :key="i">
              <div class="single">
                <label>시기</label>
                <input type="text" v-model="med_his.when" placeholder="2025-01-01">
              </div>
              <div class="single">
                <label>이유</label>
                <input type="text" v-model="med_his.why" placeholder="악성신생물(암)">
              </div>
              <div class="single">
                <label>장소</label>
                <input type="text" v-model="med_his.where" placeholder="서강대">
              </div>
              <div class="single large">
                <label>메모</label>
                <textarea v-model="med_his.memo"></textarea>
              </div>
              <button @click="deleteMedHistory(i)" class="delete"> <i class="ph-fill ph-minus-circle"></i> </button>
            </li>
            <li class="add">
              <button @click="addMedHistory">
                <i class="ph-fill ph-plus-circle"></i> 
                <span>병력 추가</span>
              </button>
            </li>
          </ul>
        </div>

        <div class="btns">
          <button @click="editDialogSwitch(false)">취소</button>
          <button class="confirm" @click="saveCustomer">저장</button>
        </div>
      </div>


      <div class="paper" v-if="editingPart == 'consultation'">
        <div class="header"> 
          <h1>📆 접촉이력</h1> 
          <span @click="editDialogSwitch(false)">X</span> 
        </div>

        <div class="content">
          <ul class="consultation-list">
            <li v-for="(history, i) in customer_history" :key="i">
              <div class="single">
                <label>시기</label>
                <input 
                  type="text" 
                  v-model="history.created_at" 
                  @click="useDatePicker(true, $event)"
                  readonly
                  placeholder="YYYY-MM-DD"
                >
              </div>
              <div class="single">
                <label>이유</label>
                <input type="text" v-model="history.title">
              </div>
              <div class="single">
                <label>장소</label>
                <input type="text" v-model="history.place">
              </div>
              <div class="single large">
                <label>메모</label>
                <textarea v-model="history.content"></textarea>
              </div>
              <div class="single">
                <label>상태</label>
                <select v-model="history.status">
                  <option v-for="(status, i) in status_types" :key="i" :value="i">{{ status }}</option>
                </select>
              </div>
              <div class="single">
                <label>다음행보</label>
                <input type="text" v-model="history.next_action">
              </div>
              <button @click="deleteHistory(i)" class="delete"> <i class="ph-fill ph-minus-circle"></i> </button>
            </li>
            <li class="add">
              <button @click="addHistory">
                <i class="ph-fill ph-plus-circle"></i> 
                <span>추가</span>
              </button>
            </li>
          </ul>
        </div>

        <div class="btns">
          <button @click="editDialogSwitch(false)">취소</button>
          <button class="confirm" @click="saveHistory">저장</button>
        </div>
      </div>


      <div class="paper" v-if="editingPart == 'event'">
        <div class="header"> 
          <h1>🎂 기념일/이벤트</h1> 
          <span @click="editDialogSwitch(false)">X</span> 
        </div>

        <div class="content">
          <div class="single">
            <label>기념일</label>
            <ul class="event-list">
              <li v-for="(event, i) in myEvents" :key="i">
                <div class="single">
                  <label>날짜</label>
                  <input type="text" v-model="event.event_datetime">
                </div>
                <div class="single">
                  <label>제목</label>
                  <input type="text" v-model="event.title">
                </div>
                <div class="single">
                  <label>설명</label>
                  <input type="text" v-model="event.text">
                </div>
                <button @click="deleteEvent(i)" class="delete"> <i class="ph-fill ph-minus-circle"></i> </button>
              </li>
              <li class="add">
                <button @click="addEvent">
                  <i class="ph-fill ph-plus-circle"></i> 
                <span>추가</span>
              </button>
            </li>
          </ul>
          </div>
        </div>

        <div class="btns">
          <button @click="editDialogSwitch(false)">취소</button>
          <button class="confirm" @click="saveEvents">저장</button>
        </div>
      </div>


      <div class="paper" v-if="editingPart == 'claims'">
        <div class="header"> 
          <h1>💰 보험금 청구</h1> 
          <span @click="editDialogSwitch(false)">X</span> 
        </div>

        <div class="content">
          <ul class="claims-list">
            <li v-for="(claim, i) in claimsList" :key="i">
              <div class="single">
                <label>보험회사</label>
                <select v-model="claim.insu_company_idx">
                  <option value="">선택</option>
                  <option v-for="company in companyList" :key="company.idx" :value="company.idx">
                    {{ company.name }}
                  </option>
                </select>
              </div>
              <div class="single">
                <label>청구일</label>
                <input 
                  type="text" 
                  v-model="claim.request_date" 
                  @click="useClaimDatePicker('request', i, $event)"
                  readonly
                  placeholder="YYYY-MM-DD"
                >
              </div>
              <div class="single">
                <label>확정일</label>
                <input 
                  type="text" 
                  v-model="claim.confirm_date" 
                  @click="useClaimDatePicker('confirm', i, $event)"
                  readonly
                  placeholder="YYYY-MM-DD"
                >
              </div>
              <div class="single">
                <label>상태</label>
                <select v-model="claim.status">
                  <option :value="0">접수</option>
                  <option :value="1">심사중</option>
                  <option :value="2">승인</option>
                  <option :value="3">지급완료</option>
                  <option :value="4">반려</option>
                </select>
              </div>
              <div class="single">
                <label>금액</label>
                <input type="number" v-model="claim.amount" placeholder="0">
              </div>
              <div class="single large">
                <label>청구내용</label>
                <textarea v-model="claim.claim_content" placeholder="청구 상세 내용"></textarea>
              </div>
              <button @click="deleteClaim(i)" class="delete">
                <i class="ph-fill ph-minus-circle"></i>
              </button>
            </li>
            <li class="add">
              <button @click="addClaim">
                <i class="ph-fill ph-plus-circle"></i> 
                <span>청구 추가</span>
              </button>
            </li>
          </ul>
        </div>

        <div class="btns">
          <button @click="editDialogSwitch(false)">취소</button>
          <button class="confirm" @click="saveClaims">저장</button>
        </div>
      </div>


      <div class="paper" v-if="editingPart == 'materials'">
        <div class="header"> 
          <h1>📁 자료보관</h1> 
          <span @click="editDialogSwitch(false)">X</span> 
        </div>

        <div class="content">
          <!-- 용량 표시 -->
          <div class="storage-info">
            <div class="storage-bar">
              <div class="storage-fill" :style="{ width: storagePercent + '%' }" :class="{ warning: storagePercent > 80, danger: storagePercent > 95 }"></div>
            </div>
            <div class="storage-text">
              <span>{{ formatFileSize(storageUsed) }} / {{ formatFileSize(storageLimit) }} 사용</span>
              <span :class="{ warning: storagePercent > 80, danger: storagePercent > 95 }">{{ storagePercent }}%</span>
            </div>
          </div>

          <!-- 업로드 영역 -->
          <div 
            class="upload-area" 
            :class="{ disabled: storagePercent >= 100 }"
            @click="storagePercent < 100 && triggerFileInput()" 
            @dragover.prevent 
            @drop.prevent="storagePercent < 100 && handleDrop($event)"
          >
            <input 
              type="file" 
              ref="fileInput" 
              @change="handleFileSelect" 
              multiple 
              accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv"
              style="display: none;"
              :disabled="storagePercent >= 100"
            >
            <template v-if="storagePercent >= 100">
              <i class="ph ph-warning-circle"></i>
              <p>저장 공간이 가득 찼습니다</p>
              <span>파일을 삭제하여 공간을 확보하세요</span>
            </template>
            <template v-else>
              <i class="ph ph-cloud-arrow-up"></i>
              <p>클릭하거나 파일을 드래그하세요</p>
              <span>이미지, PDF, 문서 파일 지원 (최대 1GB)</span>
            </template>
          </div>

          <!-- 업로드 중인 파일 -->
          <div class="uploading-list" v-if="uploadingFiles.length > 0">
            <div class="uploading-item" v-for="(file, i) in uploadingFiles" :key="i">
              <span class="file-name">{{ file.name }}</span>
              <span class="file-status">업로드 중...</span>
            </div>
          </div>

          <!-- 파일 목록 -->
          <ul class="files-edit-list">
            <li v-for="(file, i) in filesList" :key="i">
              <div class="file-icon">
                <i :class="getFileIcon(file.type)"></i>
              </div>
              <div class="file-info">
                <span class="file-title">{{ file.title }}</span>
                <span class="file-meta">{{ formatFileSize(file.size) }}</span>
              </div>
              <button @click="deleteFile(i)" class="delete">
                <i class="ph-fill ph-minus-circle"></i>
              </button>
            </li>
            <li class="empty" v-if="filesList.length === 0 && uploadingFiles.length === 0">
              <p>등록된 자료가 없습니다.</p>
            </li>
          </ul>
        </div>

        <div class="btns">
          <button @click="editDialogSwitch(false)">닫기</button>
        </div>
      </div>


      <div class="paper" v-if="editingPart == 'memo'">
        <div class="header"> 
          <h1>📝 메모 수정</h1> 
          <span @click="editDialogSwitch(false)">X</span> 
        </div>

        <div class="content">
          <div class="single">
            <label>메모</label>
            <textarea class="memo-extra" v-model="editingCustomer.notes" placholder="중요사항, 기타 정보 입력.."></textarea>
          </div>
        </div>

        <div class="btns">
          <button @click="editDialogSwitch(false)">취소</button>
          <button class="confirm" @click="saveCustomer">저장</button>
        </div>
      </div>


    </div>
  </div>
</template>

<script>
import { inject, onMounted, ref, computed } from "vue"
import dialog_wheelDateChooser from '@/components/dialogs/wheelDateChooser.vue';
import dialog_customerPicker from '@/components/dialogs/customerPicker.vue';

import dialog_customerTagEdit from "@/components/dialogs/customerTagEdit.vue";
import { useBackButton } from '@/utils/useBackBtn';

export default {
  emits: ['submit'],
  props: {
    editDialogSwitch: Function,
    customer: Object,
    reloadForSync: Function,
    gotEditingPart: String,
  },
  components: {
    dialog_wheelDateChooser,
    dialog_customerPicker,
    dialog_customerTagEdit,
  },
  setup(props) {
    const sql_query = inject('sql_query');
    const editingCustomer = ref(props.customer);
    const member_info = inject('member_info');
    const editingPart = ref(props.gotEditingPart || 'basic');
    const relation_info = ref([]);
    const customer_history = ref([]);
    const showCustomerPicker = ref(false);
    const tag_edit_show = ref(false);
    const checkCustomerMilestone = inject('checkCustomerMilestone');
    let status_types = {'new':'신규', 'in_progress':'진행중', 'done':'완료', 'follow_up':'팔로업'};

    useBackButton(() => {
      props.editDialogSwitch(false);
    });

    const datePickerShow = ref(false);
    const tempDateForWheel = ref(null);
    const dateInputTarget = ref(null);

    const newTag = ref('');
    const tagList = ref([]);

    const firstCivNum = ref('');
    const lastCivNum = ref('');

    const prevBirthLength = ref(0);
    function formatBirth(e) {
      const currentLength = e.target.value.length;
      const isDeleting = currentLength < prevBirthLength.value;
      
      prevBirthLength.value = currentLength;
      
      // 삭제 중이면 포맷팅 안 함
      if (isDeleting) {
        editingCustomer.value.birth = e.target.value;
        return;
      }
      
      let value = e.target.value.replace(/[^0-9]/g, ''); // 숫자만
      
      if (value.length >= 4) {
        value = value.slice(0, 4) + '-' + value.slice(4);
      }
      if (value.length >= 7) {
        value = value.slice(0, 7) + '-' + value.slice(7, 9);
      }
      
      editingCustomer.value.birth = value;
    }

    firstCivNum.value = editingCustomer.value.rrn?.split('-')[0];
    lastCivNum.value = editingCustomer.value.rrn?.split('-')[1];

    // 프로필 이미지 관련
    const profileInput = ref(null);
    const isUploadingProfile = ref(false);

    function triggerProfileInput() {
      if (isUploadingProfile.value) return;
      profileInput.value?.click();
    }

    async function handleProfileSelect(event) {
      const file = event.target.files?.[0];
      if (!file) return;

      // 이미지 파일 검증
      if (!file.type.startsWith('image/')) {
        alert('이미지 파일만 업로드 가능합니다.');
        return;
      }

      // 파일 크기 제한 (5MB)
      if (file.size > 5 * 1024 * 1024) {
        alert('파일 크기는 5MB 이하만 가능합니다.');
        return;
      }

      isUploadingProfile.value = true;

      try {
        const formData = new FormData();
        formData.append('idx', editingCustomer.value.idx);
        formData.append('table', 'customers');
        formData.append('usage', 'customer_profile');
        formData.append('user', member_info.mb_id);
        formData.append('file', file);

        const response = await fetch('/api/upload/image', {
          method: 'POST',
          body: formData,
          mode: 'cors',
          credentials: 'include'
        });

        const data = await response.json();

        if (data.success && data.url) {
          editingCustomer.value.image = data.url;
          
          // DB에 바로 저장
          const sql = `UPDATE customers SET image = '${data.url}' WHERE idx = ${editingCustomer.value.idx}`;
          await sql_query(sql);
          
          props.reloadForSync?.();
        } else {
          alert(`업로드 실패: ${data.message || '알 수 없는 오류'}`);
        }
      } catch (err) {
        console.error('프로필 업로드 실패:', err);
        alert('업로드 중 오류가 발생했습니다.');
      } finally {
        isUploadingProfile.value = false;
        event.target.value = '';
      }
    }

    async function removeProfileImage() {
      if (!confirm('프로필 사진을 삭제하시겠습니까?')) return;

      try {
        editingCustomer.value.image = null;
        
        // DB에서 삭제
        const sql = `UPDATE customers SET image = NULL WHERE idx = ${editingCustomer.value.idx}`;
        await sql_query(sql);
        
        props.reloadForSync?.();
      } catch (err) {
        console.error('프로필 삭제 실패:', err);
        alert('삭제 중 오류가 발생했습니다.');
      }
    }

    function reloadTagList() {
      fetchMyTags();
      props.reloadForSync();
    }

    function tagEditSwitch(value) {
      tag_edit_show.value = value;
    }

    const myEvents = ref([]);
    async function fetchMyEvents() {
      let sql = `SELECT * FROM customer_events WHERE customer_idx = '${editingCustomer.value.idx}'`;
      let result = await sql_query(sql);
      myEvents.value = result;
    }
    fetchMyEvents();

    async function addEvent() {
      let sql = `INSERT INTO customer_events SET customer_idx = '${editingCustomer.value.idx}', event_datetime = CURDATE(), title = '', text = ''`;
      await sql_query(sql);
      fetchMyEvents();
    }

    // deleteEvent 함수 수정
    async function deleteEvent(index) {
      if (!confirm('정말로 삭제하시겠습니까?')) return;
      let sql = `DELETE FROM customer_events WHERE idx = '${myEvents.value[index].idx}'`;
      await sql_query(sql);
      fetchMyEvents();
      props.reloadForSync();
    }

    async function saveEvents() {
      for (const event of myEvents.value) {
        let sql = `
          UPDATE customer_events SET
            event_datetime = '${escapeStr(event.event_datetime)}',
            title = '${escapeStr(event.title)}',
            text = ${event.text ? `'${escapeStr(event.text)}'` : 'NULL'}
          WHERE idx = ${event.idx}
        `;
        console.log(sql);
        await sql_query(sql);
      }
      props.reloadForSync();
      props.editDialogSwitch(false);
    }

    const myAllTags = ref([]);
    async function fetchMyTags() {
      let sql = `SELECT * FROM customer_tag WHERE mb_id = '${member_info.mb_id}'`;
      let result = await sql_query(sql);
      myAllTags.value = result;
    }
    fetchMyTags();

    // editingCustomer가 로드되면 tags를 파싱
    onMounted(() => {
      
      if (editingCustomer.value.tags) {
        // 이미 배열이면 그대로 사용
        if (Array.isArray(editingCustomer.value.tags)) {
          tagList.value = editingCustomer.value.tags;
        } 
        // 문자열이면 파싱
        else if (typeof editingCustomer.value.tags === 'string') {
          try {
            tagList.value = JSON.parse(editingCustomer.value.tags);
          } catch (e) {
            console.error('JSON 파싱 에러:', e);
            tagList.value = [];
          }
        }
      }
    });

    function toggleTag(tag) {
      if (tagList.value.includes(tag.name)) {
        tagList.value.splice(tagList.value.indexOf(tag.name), 1);
      } else {
        tagList.value.push(tag.name);
      }
    }
    
    function addTag() {
      if (newTag.value.trim()) {
        tagList.value.push(newTag.value.trim());
        newTag.value = '';
      }
    }
    
    function removeTag(index) {
      tagList.value.splice(index, 1);
    }

    function addHistory() {
      customer_history.value.push({
        customer_idx: editingCustomer.value.idx,
        type: 'other',
        title: '',
        place: '',
        content: '',
        status: 'new',
        next_action: '',
        created_at: new Date().toISOString()
      });
    }

    async function deleteHistory(index) {
      if (confirm('정말로 삭제하시겠습니까?')) {
        const history = customer_history.value[index];
        
        // DB에 이미 저장된 항목이면 DB에서도 삭제
        if (history.idx) {
          let sql = `DELETE FROM customer_history WHERE idx = ${history.idx}`;
          await sql_query(sql);
        }
        
        // 배열에서 제거
        customer_history.value.splice(index, 1);
      }
    }

    async function saveHistory() {
      // customer_history의 각 항목을 저장/업데이트
      for (const history of customer_history.value) {
        if (history.idx) {
          // 기존 항목 업데이트
          let sql = `
            UPDATE customer_history SET
              type = '${escapeStr(history.type || 'other')}',
              title = '${escapeStr(history.title)}',
              place = ${history.place ? `'${escapeStr(history.place)}'` : 'NULL'},
              content = ${history.content ? `'${escapeStr(history.content)}'` : 'NULL'},
              status = '${escapeStr(history.status || 'new')}',
              next_action = ${history.next_action ? `'${escapeStr(history.next_action)}'` : 'NULL'}
            WHERE idx = ${history.idx}
          `;
          await sql_query(sql);
          setTimeout(() => {
            props.reloadForSync();
          }, 200);
          
          props.editDialogSwitch(false);
        } else {
          // 새 항목 추가
          let sql = `
            INSERT INTO customer_history SET
              mb_id = '${member_info.mb_id}',
              customer_idx = ${editingCustomer.value.idx},
              type = '${escapeStr(history.type || 'other')}',
              title = '${escapeStr(history.title)}',
              place = ${history.place ? `'${escapeStr(history.place)}'` : 'NULL'},
              content = ${history.content ? `'${escapeStr(history.content)}'` : 'NULL'},
              status = '${escapeStr(history.status || 'new')}',
              next_action = ${history.next_action ? `'${escapeStr(history.next_action)}'` : 'NULL'},
              created_at = NOW()
          `;
          await sql_query(sql);
          setTimeout(() => {
            props.reloadForSync();
          }, 200);
          
          props.editDialogSwitch(false);
        }
      }
    }

    async function fetchCustomerHistory() {
      let sql = `select * from customer_history where customer_idx = ${editingCustomer.value.idx}`;
      let result = await sql_query(sql);
      customer_history.value = result;
    }
    fetchCustomerHistory();

    const med_history_list = ref(
      props.customer.med_history 
        ? JSON.parse(props.customer.med_history) 
        : []
    );

    function addMedHistory() {
      med_history_list.value.push({
        when: '',
        why: '',
        where: '',
        memo: ''
      });
    }

    function deleteMedHistory(index) {
      if (confirm('정말로 삭제하시겠습니까?')) {
        med_history_list.value.splice(index, 1);
      }
    }

    function customerPickerSwitch(show) {
      showCustomerPicker.value = show;
    }

    function handleCustomerPickerSubmit(sel_customer) {
      console.log('📦 CustomerPickerShow:', sel_customer);
      customerPickerSwitch(false);

      if (sel_customer?.customer?.idx) {
        addRelation(sel_customer.customer);
      }
    }

    async function addRelation(cusInfo) {
      let sql = `
        INSERT INTO customer_relations set 
          customer_idx = ${editingCustomer.value.idx},
          link_to = ${cusInfo.idx},
          relation_type = '';
      `;
      console.log(sql);
      await sql_query(sql);
      getRelations();
    }

    const relation_type_list = [
      "아버지",
      "어머니",
      "배우자",
      "자녀",
      "조부",
      "조모",
      "외조부",
      "외조모",
      "형제자매",
      "사촌관계",
      "친구",
      "동료",
      "지인",
      "선후배",
      "스승",
      "제자"
    ]

    const relation_to_me_list = [
      "친구",
      "지인",
      "가족",
      "친척",
      "학교동기",
      "직장동료",
      "선후배",
      "이웃",
      "교회/종교",
      "소개",
      "기존고객",
      "SNS",
      "고객의 가족",
      "고객의 지인",
    ]

    // 나와의 관계 - 직접 입력 모드
    const relationToMeSelected = ref('');
    const relationToMeCustomMode = ref(false);

    // 초기값 세팅
    if (editingCustomer.value.relation_to_me) {
      const val = editingCustomer.value.relation_to_me;
      if (relation_to_me_list.includes(val)) {
        relationToMeSelected.value = val;
        relationToMeCustomMode.value = false;
      } else {
        relationToMeSelected.value = '__custom__';
        relationToMeCustomMode.value = true;
      }
    }

    function onRelationToMeChange() {
      if (relationToMeSelected.value === '__custom__') {
        relationToMeCustomMode.value = true;
        editingCustomer.value.relation_to_me = '';
      } else {
        relationToMeCustomMode.value = false;
        editingCustomer.value.relation_to_me = relationToMeSelected.value;
      }
    }

    // 가족관계 - 직접 입력 모드
    function onFamilyRelationChange(member, event) {
      if (event.target.value === '__custom__') {
        member._customMode = true;
        member.relation_type = '';
      } else {
        member._customMode = false;
        updateRelationType(member);
      }
    }

    async function getRelations() {
      let sql = `
        SELECT 
          cr.*,
          c.idx as linked_customer_idx,
          c.name as linked_customer_name,
          c.nickname as linked_customer_nickname,
          c.phone as linked_customer_phone,
          c.rrn as linked_customer_rrn
        FROM customer_relations cr
        LEFT JOIN customers c ON cr.link_to = c.idx
        WHERE cr.customer_idx = ${editingCustomer.value.idx}
      `;
      let result = await sql_query(sql);
      // 기존에 직접 입력된 관계인지 체크
      result.forEach(member => {
        member._customMode = member.relation_type && !relation_type_list.includes(member.relation_type);
      });
      relation_info.value = result;
    }
    getRelations();

    async function updateRelationType(member) {
      let sql = `
        UPDATE customer_relations
        SET relation_type = '${member.relation_type}'
        WHERE idx = ${member.idx}
      `;
      await sql_query(sql);
    }

    async function deleteRelation(member) {
      let ask = confirm('정말로 삭제하시겠습니까?');
      if (!ask) return;
      let sql = `
        DELETE FROM customer_relations
        WHERE idx = ${member.idx}
      `;
      await sql_query(sql);
      getRelations();
    }

    function escapeStr(value) {
      if (value !== null && value !== undefined) {
        return String(value).replace(/'/g, "\\'");
      } else {
        return null;
      }
    }
      

    function useDatePicker(show, event) {
      datePickerShow.value = show;
      
      if (show && event?.target instanceof HTMLInputElement) {
        dateInputTarget.value = event.target;
        tempDateForWheel.value = event.target.value || null;
      }
    }

    function handleDateSubmit({ year, month, day }) {
      const mm = String(month).padStart(2, '0');
      const dd = String(day).padStart(2, '0');
      const dateStr = `${year}-${mm}-${dd}`;
      
      // 청구 날짜 처리
      if (claimDateTarget.value.index >= 0) {
        const claim = claimsList.value[claimDateTarget.value.index];
        if (claimDateTarget.value.type === 'request') {
          claim.request_date = dateStr;
        } else if (claimDateTarget.value.type === 'confirm') {
          claim.confirm_date = dateStr;
        }
        claimDateTarget.value = { type: '', index: -1 };
      } else {
        // 기존 로직 (생년월일 등)
        editingCustomer.value.rrn = dateStr;
      }
      
      datePickerShow.value = false;
    }

    function toMySQLDatetime(value) {
      if (!value) return null;
      // 이미 MySQL 형식이면 그대로
      if (!value.includes('T')) return value;
      // ISO → MySQL 형식 변환
      return value.replace('T', ' ').replace(/\.\d{3}Z$/, '').replace('Z', '');
    }

    function saveCustomer() {
      if (!editingCustomer.value.name) {
        alert("성명은 필수 입력사항입니다.");
        return;
      }

      const c = editingCustomer.value;
      const isNew = c.idx === null || c.idx === undefined;

      // rrn 조합 (앞자리만 있어도 저장)
      const first = firstCivNum.value?.trim() || '';
      const last = lastCivNum.value?.trim() || '';
      if (first && last) {
        c.rrn = `${first}-${last}`;
      } else if (first) {
        c.rrn = first;
      } else {
        c.rrn = null;
      }

      // ★ 실제생일 없으면 주민번호에서 자동 생성
      if (!c.birth?.trim() && first.length === 6) {
        const yy = first.slice(0, 2);
        const mm = first.slice(2, 4);
        const dd = first.slice(4, 6);
        
        let century;
        if (last && last.length > 0) {
          // 뒷자리 있으면 성별코드로 판단
          const genderDigit = last.charAt(0);
          century = (genderDigit === '1' || genderDigit === '2') ? '19' : '20';
        } else {
          // 뒷자리 없으면 앞자리로 추정 (00~30은 2000년대, 31~99는 1900년대)
          const yyNum = parseInt(yy, 10);
          century = (yyNum <= 30) ? '20' : '19';
        }
        
        c.birth = `${century}${yy}-${mm}-${dd}`;
      }

      // undefined / null 제거 + 문자열만
      const cleanArray = (arr) =>
        Array.isArray(arr)
          ? arr.filter(v => v !== undefined && v !== null && v !== '')
          : [];

      // tags
      const tagsArr = cleanArray(tagList.value);
      const tagsStr = tagsArr.length > 0
        ? `'${escapeStr(JSON.stringify(tagsArr))}'`
        : 'NULL';

      // med_history
      const medArr = cleanArray(med_history_list.value);
      const medHistoryStr = medArr.length > 0
        ? `'${escapeStr(JSON.stringify(medArr))}'`
        : 'NULL';


      const sql = isNew
        ? `INSERT INTO customers SET
            mb_id = '${member_info.mb_id}',
            name = '${escapeStr(c.name)}',
            nickname = '${escapeStr(c.nickname)}',
            title = '${escapeStr(c.title)}',
            m_type = '${escapeStr(c.m_type)}',
            rrn = ${c.rrn?.trim() ? `'${escapeStr(c.rrn)}'` : 'NULL'},
            birth = ${c.birth?.trim() ? `'${escapeStr(c.birth)}'` : 'NULL'},
            sex = ${c.sex ?? 0},
            address = ${c.address ? `'${escapeStr(c.address)}'` : 'NULL'},
            location = ${c.location ? `'${escapeStr(c.location)}'` : 'NULL'},
            ex_address = ${c.ex_address ? `'${escapeStr(c.ex_address)}'` : 'NULL'},
            phone = ${c.phone ? `'${escapeStr(c.phone)}'` : 'NULL'},
            job = ${c.job ? `'${escapeStr(c.job)}'` : 'NULL'},
            job_grade = ${c.job_grade ? `'${escapeStr(c.job_grade)}'` : 'NULL'},
            job_name = ${c.job_name ? `'${escapeStr(c.job_name)}'` : 'NULL'},
            job_dept = ${c.job_dept ? `'${escapeStr(c.job_dept)}'` : 'NULL'},
            job_adrs = ${c.job_adrs ? `'${escapeStr(c.job_adrs)}'` : 'NULL'},
            job_phone = ${c.job_phone ? `'${escapeStr(c.job_phone)}'` : 'NULL'},
            notes = ${c.notes ? `'${escapeStr(c.notes)}'` : 'NULL'},
            tags = ${tagsStr},
            med_history = ${medHistoryStr},
            is_keyman = ${c.is_keyman ?? 0},
            is_official = ${c.is_official ?? 0},
            vip_rank = ${c.vip_rank ?? 0},
            manage_rank = ${c.manage_rank ? `'${escapeStr(c.manage_rank)}'` : 'NULL'},
            sns_talk = ${c.sns_talk ? `'${escapeStr(c.sns_talk)}'` : 'NULL'},
            sns_ama = ${c.sns_ama ? `'${escapeStr(c.sns_ama)}'` : 'NULL'},
            sns_etc = ${c.sns_etc ? `'${escapeStr(c.sns_etc)}'` : 'NULL'},
            agree_privacy = ${c.agree_privacy ?? 0},
            agree_privacy_at = ${c.agree_privacy_at ? `'${toMySQLDatetime(c.agree_privacy_at)}'` : 'NULL'},
            agree_sms = ${c.agree_sms ?? 0},
            agree_sms_at = ${c.agree_sms_at ? `'${toMySQLDatetime(c.agree_sms_at)}'` : 'NULL'},
            agree_email = ${c.agree_email ?? 0},
            agree_email_at = ${c.agree_email_at ? `'${toMySQLDatetime(c.agree_email_at)}'` : 'NULL'},
            image = ${c.image ? `'${escapeStr(c.image)}'` : 'NULL'},
            relation_to_me = ${c.relation_to_me ? `'${escapeStr(c.relation_to_me)}'` : 'NULL'},
            created_at = NOW()`
        : `UPDATE customers SET
            name = '${escapeStr(c.name)}',
            nickname = ${c.nickname ? `'${escapeStr(c.nickname)}'` : 'NULL'},
            title = ${c.title ? `'${escapeStr(c.title)}'` : 'NULL'},
            m_type = ${c.m_type ? `'${escapeStr(c.m_type)}'` : 'NULL'},
            rrn = ${c.rrn?.trim() ? `'${escapeStr(c.rrn)}'` : 'NULL'},
            birth = ${c.birth?.trim() ? `'${escapeStr(c.birth)}'` : 'NULL'},
            sex = ${c.sex ?? 0},
            address = ${c.address ? `'${escapeStr(c.address)}'` : 'NULL'},
            location = ${c.location ? `'${escapeStr(c.location)}'` : 'NULL'},
            ex_address = ${c.ex_address ? `'${escapeStr(c.ex_address)}'` : 'NULL'},
            phone = ${c.phone ? `'${escapeStr(c.phone)}'` : 'NULL'},
            job = ${c.job ? `'${escapeStr(c.job)}'` : 'NULL'},
            job_grade = ${c.job_grade ? `'${escapeStr(c.job_grade)}'` : 'NULL'},
            job_name = ${c.job_name ? `'${escapeStr(c.job_name)}'` : 'NULL'},
            job_dept = ${c.job_dept ? `'${escapeStr(c.job_dept)}'` : 'NULL'},
            job_adrs = ${c.job_adrs ? `'${escapeStr(c.job_adrs)}'` : 'NULL'},
            job_phone = ${c.job_phone ? `'${escapeStr(c.job_phone)}'` : 'NULL'},
            notes = ${c.notes ? `'${escapeStr(c.notes)}'` : 'NULL'},
            tags = ${tagsStr},
            med_history = ${medHistoryStr},
            is_keyman = ${c.is_keyman ?? 0},
            is_official = ${c.is_official ?? 0},
            vip_rank = ${c.vip_rank ?? 0},
            manage_rank = ${c.manage_rank ? `'${escapeStr(c.manage_rank)}'` : 'NULL'},
            sns_talk = ${c.sns_talk ? `'${escapeStr(c.sns_talk)}'` : 'NULL'},
            sns_ama = ${c.sns_ama ? `'${escapeStr(c.sns_ama)}'` : 'NULL'},
            sns_etc = ${c.sns_etc ? `'${escapeStr(c.sns_etc)}'` : 'NULL'},
            agree_privacy = ${c.agree_privacy ?? 0},
            agree_privacy_at = ${c.agree_privacy_at ? `'${toMySQLDatetime(c.agree_privacy_at)}'` : 'NULL'},
            agree_sms = ${c.agree_sms ?? 0},
            agree_sms_at = ${c.agree_sms_at ? `'${toMySQLDatetime(c.agree_sms_at)}'` : 'NULL'},
            agree_email = ${c.agree_email ?? 0},
            agree_email_at = ${c.agree_email_at ? `'${toMySQLDatetime(c.agree_email_at)}'` : 'NULL'},
            image = ${c.image ? `'${escapeStr(c.image)}'` : 'NULL'},
            relation_to_me = ${c.relation_to_me ? `'${escapeStr(c.relation_to_me)}'` : 'NULL'}
          WHERE idx = ${c.idx}`;

      console.log(sql);
      sql_query(sql);

      // 등록 성공 후 자동으로 마일스톤 체크
      checkCustomerMilestone(member_info.mb_id);

      window.dispatchEvent(new CustomEvent('customer-updated'));

      setTimeout(() => {
        props.reloadForSync();
      }, 200);
      
      props.editDialogSwitch(false);
    }

    // 보험금 청구 관련
    const claimsList = ref([]);
    const companyList = ref([]);
    const claimDateTarget = ref({ type: '', index: -1 });

    // 보험회사 목록 조회
    async function fetchCompanyList() {
      let sql = `SELECT idx, name FROM insu_company ORDER BY sort_no, name`;
      let result = await sql_query(sql);
      companyList.value = result;
    }
    fetchCompanyList();

    // 청구 목록 조회
    async function fetchClaims() {
      let sql = `SELECT * FROM insu_claims WHERE customer_idx = ${editingCustomer.value.idx} ORDER BY request_date DESC`;
      let result = await sql_query(sql);
      claimsList.value = result;
    }
    fetchClaims();

    function addClaim() {
      claimsList.value.push({
        customer_idx: editingCustomer.value.idx,
        claim_content: '',
        insu_company_idx: '',
        request_date: new Date().toISOString().split('T')[0],
        confirm_date: '',
        status: 0,
        amount: 0
      });
    }

    async function deleteClaim(index) {
      if (!confirm('정말로 삭제하시겠습니까?')) return;
      
      const claim = claimsList.value[index];
      if (claim.idx) {
        let sql = `DELETE FROM insu_claims WHERE idx = ${claim.idx}`;
        await sql_query(sql);
      }
      claimsList.value.splice(index, 1);
    }

    function useClaimDatePicker(type, index, event) {
      claimDateTarget.value = { type, index };
      datePickerShow.value = true;
      tempDateForWheel.value = event.target.value || null;
    }

    function toMysqlDate(dateStr) {
      return dateStr ? dateStr.split('T')[0] : null;
    }

    async function saveClaims() {
      for (const claim of claimsList.value) {
        if (!claim.insu_company_idx) {
          alert('보험회사는 필수입니다.');
          return;
        }
        
        if (claim.idx) {
          let sql = `
            UPDATE insu_claims SET
              claim_content = '${escapeStr(claim.claim_content)}',
              insu_company_idx = ${claim.insu_company_idx},
              request_date = '${toMysqlDate(claim.request_date)}',
              confirm_date = ${toMysqlDate(claim.confirm_date) ? `'${toMysqlDate(claim.confirm_date)}'` : 'NULL'},
              status = ${claim.status},
              amount = ${claim.amount || 0}
            WHERE idx = ${claim.idx}
          `;
          await sql_query(sql);
          console.log(sql)
        } else {
          let sql = `
            INSERT INTO insu_claims SET
              customer_idx = ${editingCustomer.value.idx},
              claim_content = '${escapeStr(claim.claim_content)}',
              insu_company_idx = ${claim.insu_company_idx},
              request_date = '${toMysqlDate(claim.request_date)}',
              confirm_date = ${toMysqlDate(claim.confirm_date) ? `'${toMysqlDate(claim.confirm_date)}'` : 'NULL'},
              status = ${claim.status},
              amount = ${claim.amount || 0}
          `;
          await sql_query(sql);
        }
      }
      
      props.reloadForSync();
      props.editDialogSwitch(false);
    }

    // 파일 관련
    const filesList = ref([]);
    const uploadingFiles = ref([]);
    const fileInput = ref(null);

    // 용량 관련
    const storageUsed = ref(0);
    const storageLimit = ref(1 * 1024 * 1024 * 1024); // 1GB
    const storagePercent = computed(() => {
      if (storageLimit.value === 0) return 0;
      return Math.min(100, parseFloat(((storageUsed.value / storageLimit.value) * 100).toFixed(1)));
    });

    // 용량 조회
    async function fetchStorageInfo() {
      try {
        const response = await fetch('/api/user/storage', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ user: member_info.mb_id })
        });
        const data = await response.json();
        if (data.success) {
          storageUsed.value = data.storage.used;
          storageLimit.value = data.storage.limit;
        }
      } catch (err) {
        console.error('용량 조회 실패:', err);
      }
    }
    fetchStorageInfo();

    // 파일 목록 조회
    async function fetchFiles() {
      let sql = `
        SELECT * FROM files 
        WHERE target_table = 'customers' 
        AND target_id = '${editingCustomer.value.idx}'
        AND status = 1
        ORDER BY created_at DESC
      `;
      let result = await sql_query(sql);
      filesList.value = result || [];
    }
    fetchFiles();

    function triggerFileInput() {
      if (storagePercent.value >= 100) {
        alert('저장 공간이 가득 찼습니다.\n파일을 삭제하여 공간을 확보하세요.');
        return;
      }
      fileInput.value?.click();
    }

    function handleFileSelect(event) {
      const files = event.target.files;
      if (files && files.length > 0) {
        uploadFiles(files);
      }
      event.target.value = '';
    }

    function handleDrop(event) {
      if (storagePercent.value >= 100) {
        alert('저장 공간이 가득 찼습니다.\n파일을 삭제하여 공간을 확보하세요.');
        return;
      }
      const files = event.dataTransfer.files;
      if (files && files.length > 0) {
        uploadFiles(files);
      }
    }

    async function uploadFiles(files) {
      for (const file of files) {
        // 업로드 전 용량 체크
        if (storageUsed.value + file.size > storageLimit.value) {
          const needed = formatFileSize(file.size);
          const remaining = formatFileSize(storageLimit.value - storageUsed.value);
          alert(`저장 공간이 부족합니다.\n\n필요: ${needed}\n남은 공간: ${remaining}\n\n파일을 삭제하여 공간을 확보하세요.`);
          continue;
        }

        const uploadItem = { name: file.name };
        uploadingFiles.value.push(uploadItem);

        try {
          const formData = new FormData();
          formData.append('idx', editingCustomer.value.idx);
          formData.append('table', 'customers');
          formData.append('usage', 'customer_material');
          formData.append('user', member_info.mb_id);
          formData.append('file', file);

          const isImage = file.type.startsWith('image/');
          const endpoint = isImage ? '/api/upload/image' : '/api/upload/document';

          const response = await fetch(endpoint, {
            method: 'POST',
            body: formData,
            mode: 'cors',
            credentials: 'include'
          });

          const data = await response.json();

          if (!data.success) {
            // 용량 초과 에러 처리
            if (data.code === 'STORAGE_LIMIT_EXCEEDED') {
              alert(`저장 공간이 부족합니다!\n${data.message}`);
            } else {
              alert(`${file.name} 업로드 실패: ${data.message}`);
            }
          } else {
            // 업로드 성공 시 용량 정보 업데이트
            if (data.storage) {
              storageUsed.value = data.storage.used;
            }
          }
        } catch (err) {
          console.error('업로드 실패:', err);
          alert(`${file.name} 업로드 중 오류 발생`);
        }

        const idx = uploadingFiles.value.indexOf(uploadItem);
        if (idx > -1) uploadingFiles.value.splice(idx, 1);
      }

      fetchFiles();
      props.reloadForSync();
    }

    async function deleteFile(index) {
      if (!confirm('정말로 삭제하시겠습니까?')) return;
      
      const file = filesList.value[index];
      if (file.idx) {
        let sql = `UPDATE files SET status = 0 WHERE idx = ${file.idx}`;
        await sql_query(sql);
        
        // 용량 정보 갱신
        storageUsed.value = Math.max(0, storageUsed.value - (file.size || 0));
      }
      filesList.value.splice(index, 1);
      props.reloadForSync();
    }

    function getFileIcon(type) {
      if (!type) return 'ph ph-file';
      if (type.includes('image')) return 'ph ph-image';
      if (type.includes('pdf')) return 'ph ph-file-pdf';
      if (type.includes('word') || type.includes('document')) return 'ph ph-file-doc';
      if (type.includes('excel') || type.includes('sheet')) return 'ph ph-file-xls';
      if (type.includes('powerpoint') || type.includes('presentation')) return 'ph ph-file-ppt';
      if (type.includes('text')) return 'ph ph-file-text';
      return 'ph ph-file';
    }

    function formatFileSize(bytes) {
      if (!bytes) return '0 B';
      const k = 1024;
      const sizes = ['B', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
    }

    // setup 내부에 추가

    function formatDate(dateStr) {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}.${month}.${day}`;
    }

    function toggleAgreement(type) {
      const now = new Date().toISOString().slice(0, 19).replace('T', ' ');
      
      if (type === 'privacy') {
        if (editingCustomer.value.agree_privacy == 1) {
          editingCustomer.value.agree_privacy = 0;
          editingCustomer.value.agree_privacy_at = null;
        } else {
          editingCustomer.value.agree_privacy = 1;
          editingCustomer.value.agree_privacy_at = now;
        }
      } else if (type === 'sms') {
        if (editingCustomer.value.agree_sms == 1) {
          editingCustomer.value.agree_sms = 0;
          editingCustomer.value.agree_sms_at = null;
        } else {
          editingCustomer.value.agree_sms = 1;
          editingCustomer.value.agree_sms_at = now;
        }
      } else if (type === 'email') {
        if (editingCustomer.value.agree_email == 1) {
          editingCustomer.value.agree_email = 0;
          editingCustomer.value.agree_email_at = null;
        } else {
          editingCustomer.value.agree_email = 1;
          editingCustomer.value.agree_email_at = now;
        }
      }
    }

    return {
      saveCustomer,
      editingCustomer,
      useDatePicker,
      datePickerShow,
      handleDateSubmit,
      tempDateForWheel,
      editingPart,
      relation_info,
      relation_type_list,
      relation_to_me_list,
      relationToMeSelected,
      relationToMeCustomMode,
      onRelationToMeChange,
      onFamilyRelationChange,
      updateRelationType,
      deleteRelation,
      showCustomerPicker,
      customerPickerSwitch,
      handleCustomerPickerSubmit,
      med_history_list,
      addMedHistory,
      deleteMedHistory,
      customer_history,
      addHistory,
      deleteHistory,
      saveHistory,
      status_types,
      newTag,
      tagList,
      addTag,
      removeTag,
      myAllTags,
      toggleTag,
      myEvents,
      addEvent,
      deleteEvent,
      saveEvents,
      firstCivNum,
      lastCivNum,
      tagEditSwitch,
      reloadTagList,
      tag_edit_show,
      claimsList,
      companyList,
      addClaim,
      deleteClaim,
      saveClaims,
      useClaimDatePicker,
      filesList,
      uploadingFiles,
      fileInput,
      triggerFileInput,
      handleFileSelect,
      handleDrop,
      deleteFile,
      getFileIcon,
      formatFileSize,
      storageUsed,
      storageLimit,
      storagePercent,
      formatDate,
      toggleAgreement,
      formatBirth,
      // 프로필 이미지 관련
      profileInput,
      isUploadingProfile,
      triggerProfileInput,
      handleProfileSelect,
      removeProfileImage,
    }
  }
}
</script>


<style scoped>
#dialog-customerEdit {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
}

#dialog-customerEdit .dialog {
  position: absolute;
  left:0;
  top:0;
  width:100%;
  height:100%;
  background: var(--color-surface);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 999;
  backdrop-filter: blur(2px);
}

.cls {
  width:100%;
  height:100%;
  position:absolute;
  left:0;
  top:0;
  z-index: -1;
}

.dialog > .paper {
  position: relative;
  width: 100%;
  max-width:600px;
  height: 80%;
  background-color: var(--color-background);
  border:1px solid var(--color-text-primary);
  border-radius: 16px;
  padding: 16px;
  box-sizing: border-box;
  overflow:scroll;
  display:flex;
  flex-direction: column;
  gap:16px;
}

.dialog > .paper::-webkit-scrollbar {
  display: none;
}

.dialog > .paper > .header {
  width:100%;
  height:48px;
  display:flex;
  justify-content: space-between;
  align-items: center;
  font-size: var(--font-size-lg);
}

.dialog > .paper > .header > h1 {
  font-size:20px;
}

.dialog > .paper > .header > span {
  width:48px;
  height:48px;
  display:flex;
  justify-content: center;
  align-items: center;
  cursor:pointer;
}

.dialog > .paper > div > h2 {
  font-size:16px;
}

.dialog > .paper > .content {
  width:100%;
  height:80%;
  flex:1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  gap: 16px;
}

.dialog > .paper > .content::-webkit-scrollbar {
  display: none;
}


.dialog > .paper > .content input,
.dialog > .paper > .content textarea,
.dialog > .paper > .content select {
  width:100%;
  height:36px;
  border-radius:6px;
  border:none;
  padding:6px 12px;
  box-sizing: border-box;
  background: var(--color-surface-reverse);
}

.dialog > .paper > .content textarea.memo-extra {
  height:240px !important;
}

.dialog > .paper > .content select {
  width:100%;
  height:36px;
  border-radius:6px;
  border:none;
  padding:6 12px;
  box-sizing: border-box;
}

.dialog > .paper > .content .double {
  display:flex;
  gap:16px;
  flex-direction: row;
}

.dialog > .paper > .content .single {
  width:100%;
  display:flex;
  flex-direction: column;
  gap:6px;
}

.dialog > .paper > .content ul.family-list {
  width:100%;
  display:flex;
  flex-direction: column;
  gap:6px;
  padding:0;
  margin:0;
  list-style: none;
  gap:12px;
}

.dialog > .paper > .content ul.family-list li {
  display:flex;
  justify-content: space-between;
  align-items: center;
  background:var(--color-background-light);
  padding:12px;
  border-radius: 12px;
}

.dialog > .paper > .content ul.family-list li span {
  width:100%;
  flex:1;
  padding:0 12px;
  box-sizing: border-box; 
  text-align: center;
}

.dialog > .paper > .content ul.family-list li .delete {
  width:48px;
  height:48px;
  display:flex;
  justify-content: center;
  align-items: center;
  cursor:pointer;
  background:none;
  border:none;
  font-size:24px;
  color:var(--color-special-warning);
}

.dialog > .paper > .content ul.family-list li .add {
  width:100%;
  height:48px;
  display:flex;
  justify-content: start;
  align-items: center;
  cursor:pointer;
  background:none;
  border:none;
  font-size:24px;
  color:var(--color-brand);
}

.dialog > .paper > .content ul.family-list li .add > span {
  font-size: var(--font-size-md);
  text-align: start;
}

.dialog > .paper > .content ul.family-list li .view-card {
  width:48px;
  height:48px;
  display:flex;
  justify-content: center;
  align-items: center;
  cursor:pointer;
}

.dialog > .paper > .content ul.med-his-list {
  width:100%;
  display:flex;
  flex-direction: column;
  gap:6px;
  padding:0;
  margin:0;
  list-style: none;
  gap:12px;
}

.dialog > .paper > .content ul.med-his-list li {
  display:grid;
  grid-template-columns: repeat(3, 1fr);
  background:var(--color-background-light);
  padding:12px;
  border-radius: 12px;
  gap:12px;
  position:relative;
}

.dialog > .paper > .content ul.med-his-list {
  width:100%;
  display:flex;
  flex-direction: column;
  gap:6px;
  padding:0;
  margin:0;
  list-style: none;
  gap:12px;
}

.dialog > .paper > .content ul.med-his-list li {
  display:grid;
  grid-template-columns: repeat(3, 1fr);
  background:var(--color-background-light);
  padding:12px;
  border-radius: 12px;
  gap:12px;
  position:relative;
}

.dialog > .paper > .content ul.med-his-list li .large {
  grid-column: span 3;
  height:80px;
}

.dialog > .paper > .content ul.med-his-list li .large textarea {
  height:100%;
}

.dialog > .paper > .content ul.med-his-list li .delete {
  position:absolute;
  width: 36px;
  height: 36px;
  right: 0;
  top: 0;
  display:flex;
  justify-content: center;
  align-items: center;
  cursor:pointer;
  color:var(--color-special-warning);
  font-size: 24px;
  background:none;
  border: none;
}

.dialog > .paper > .content ul.med-his-list li.add button {
  width:100%;
  height:36px;
  display:flex;
  justify-content: start;
  align-items: center;
  cursor:pointer;
  background:none;
  border:none;
  font-size:20px;
  color:var(--color-brand);
  gap:6px;
}

.dialog > .paper > .content ul.consultation-list {
  width:100%;
  display:flex;
  flex-direction: column;
  gap:6px;
  padding:0;
  margin:0;
  list-style: none;
  gap:12px;
}

.dialog > .paper > .content ul.consultation-list li {
  display:grid;
  grid-template-columns: repeat(3, 1fr);
  background:var(--color-background-light);
  padding:12px;
  border-radius: 12px;
  gap:12px;
  position:relative;
}

.dialog > .paper > .content ul.consultation-list li .large {
  grid-column: span 3;
  height:80px;
}

.dialog > .paper > .content ul.consultation-list li .large textarea {
  height:100%;
}

.dialog > .paper > .content ul.consultation-list li .delete {
  position:absolute;
  width: 36px;
  height: 36px;
  right: 0;
  top: 0;
  display:flex;
  justify-content: center;
  align-items: center;
  cursor:pointer;
  color:var(--color-special-warning);
  font-size: 24px;
  background:none;
  border: none;
}

.dialog > .paper > .content ul.consultation-list li.add button {
  width:100%;
  height:36px;
  display:flex;
  justify-content: start;
  align-items: center;
  cursor:pointer;
  background:none;
  border:none;
  font-size:20px;
  color:var(--color-brand);
  gap:6px;
}



.dialog > .paper > .content ul.event-list {
  width:100%;
  display:flex;
  flex-direction: column;
  gap:6px;
  padding:0;
  margin:0;
  list-style: none;
  gap:12px;
}

.dialog > .paper > .content ul.event-list li {
  display:grid;
  grid-template-columns: repeat(3, 1fr);
  background:var(--color-background-light);
  padding:12px;
  border-radius: 12px;
  gap:12px;
  position:relative;
}

.dialog > .paper > .content ul.event-list li .large {
  grid-column: span 3;
  height:80px;
}

.dialog > .paper > .content ul.event-list li .large textarea {
  height:100%;
}

.dialog > .paper > .content ul.event-list li .delete {
  position:absolute;
  width: 36px;
  height: 36px;
  right: 0;
  top: 0;
  display:flex;
  justify-content: center;
  align-items: center;
  cursor:pointer;
  color:var(--color-special-warning);
  font-size: 24px;
  background:none;
  border: none;
}

.dialog > .paper > .content ul.event-list li.add button {
  width:100%;
  height:36px;
  display:flex;
  justify-content: start;
  align-items: center;
  cursor:pointer;
  background:none;
  border:none;
  font-size:20px;
  color:var(--color-brand);
  gap:6px;
}


.dialog > .paper > .btns {
  display: flex;
  justify-content: center;
  gap: 8px;
}

.dialog > .paper > .btns > button {
  height:36px;
  border-radius: 6px;
  border: none;
  flex: 1;
  background: var(--color-background-light);
  color: var(--color-text-primary);
  font-size: var(--font-size-md);
  font-weight: 600;
  cursor: pointer;
}

.dialog > .paper > .btns > button.confirm {
  background: var(--color-brand);
  color: var(--color-text-black);
}

.tag-container {
  display: flex;
  flex-wrap: wrap;
}

.tag-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  padding: 8px;
  border-radius: 4px;
  min-height: 40px;
}

.tag-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: var(--color-background-light);
  color: var(--color-text-primary);
  padding: 4px 8px;
  border-radius: 16px;
  font-size: 14px;
  cursor:pointer;
}

.tag-item.checked {
  background: var(--color-brand);
  color: var(--color-text-black);
}

.tag-remove {
  background: none;
  border: none;
  color: #666;
  cursor: pointer;
  font-size: 12px;
  padding: 0 2px;
  line-height: 1;
}

.tag-remove:hover {
  color: #f44336;
}

.tag-input {
  flex: 1;
  border: none;
  outline: none;
  min-width: 100px;
  padding: 4px;
}

.tag-add {
  background: #4caf50;
  color: white;
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  cursor: pointer;
  font-size: 18px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tag-add:hover {
  background: #45a049;
}

.dialog > .paper > .content ul.claims-list {
  width:100%;
  display:flex;
  flex-direction: column;
  padding:0;
  margin:0;
  list-style: none;
  gap:12px;
}

.dialog > .paper > .content ul.claims-list li {
  display:grid;
  grid-template-columns: repeat(3, 1fr);
  background:var(--color-background-light);
  padding:12px;
  border-radius: 12px;
  gap:12px;
  position:relative;
}

.dialog > .paper > .content ul.claims-list li .large {
  grid-column: span 3;
  height:80px;
}

.dialog > .paper > .content ul.claims-list li .large textarea {
  height:100%;
}

.dialog > .paper > .content ul.claims-list li .delete {
  position:absolute;
  width: 36px;
  height: 36px;
  right: 0;
  top: 0;
  display:flex;
  justify-content: center;
  align-items: center;
  cursor:pointer;
  color:var(--color-special-warning);
  font-size: 24px;
  background:none;
  border: none;
}

.dialog > .paper > .content ul.claims-list li.add button {
  width:100%;
  height:36px;
  display:flex;
  justify-content: start;
  align-items: center;
  cursor:pointer;
  background:none;
  border:none;
  font-size:20px;
  color:var(--color-brand);
  gap:6px;
}

/* Upload Area */
.upload-area {
  border: 2px dashed var(--color-text-third);
  border-radius: 12px;
  padding: 32px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.upload-area:hover {
  border-color: var(--color-brand);
  background: var(--color-surface);
}

.upload-area i {
  font-size: 48px;
  color: var(--color-brand);
}

.upload-area p {
  margin: 0;
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-primary);
}

.upload-area span {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
}

/* Uploading List */
.uploading-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.uploading-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  background: var(--color-surface);
  border-radius: 8px;
}

.uploading-item .file-name {
  flex: 1;
  font-size: var(--font-size-sm);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.uploading-item .file-status {
  font-size: var(--font-size-sm);
  color: var(--color-brand);
}

/* Files Edit List */
.dialog > .paper > .content ul.files-edit-list {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0;
  list-style: none;
  gap: 12px;
}

.dialog > .paper > .content ul.files-edit-list li {
  display: flex;
  align-items: center;
  gap: 12px;
  background: var(--color-background-light);
  padding: 12px;
  border-radius: 12px;
}

.dialog > .paper > .content ul.files-edit-list li.empty {
  justify-content: center;
  padding: 32px;
}

.dialog > .paper > .content ul.files-edit-list li.empty p {
  margin: 0;
  color: var(--color-text-secondary);
}

.dialog > .paper > .content ul.files-edit-list .file-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-surface);
  border-radius: 8px;
  font-size: 20px;
  color: var(--color-brand);
}

.dialog > .paper > .content ul.files-edit-list .file-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.dialog > .paper > .content ul.files-edit-list .file-title {
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
  color: var(--color-text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dialog > .paper > .content ul.files-edit-list .file-meta {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
}

.dialog > .paper > .content ul.files-edit-list .delete {
  width: 36px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: var(--color-special-warning);
  font-size: 24px;
  background: none;
  border: none;
}

/* 수신동의 편집 스타일 */
.agreement-edit-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: var(--color-background-light);
  border-radius: 12px;
  padding: 8px;
}

.agreement-edit-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  cursor: pointer;
  border-radius: 8px;
  transition: background 0.2s;
}

.agreement-edit-item:hover {
  background: var(--color-surface);
}

.agreement-edit-item .checkbox {
  width: 22px;
  height: 22px;
  border: 2px solid var(--color-text-secondary);
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s;
  flex-shrink: 0;
}

.agreement-edit-item .checkbox.checked {
  background: var(--color-brand);
  border-color: var(--color-brand);
  color: var(--color-text-black);
}

.agreement-edit-item .agreement-info {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
}

.agreement-edit-item .label {
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
  color: var(--color-text-primary);
}

.agreement-edit-item .badge {
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: var(--font-weight-bold);
}

.agreement-edit-item .badge.required {
  background: var(--color-special-point);
  color: var(--color-text-white);
}

.agreement-edit-item .badge.optional {
  background: var(--color-surface);
  color: var(--color-text-secondary);
}

.agreement-edit-item .date {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
  white-space: nowrap;
}

/* 프로필 이미지 섹션 */
.custom-select-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.custom-select-wrapper select {
  width: 100%;
}

.custom-select-wrapper .custom-input {
  width: 100%;
  padding: 10px 14px;
  border: 2px dashed var(--color-brand);
  border-radius: 8px;
  font-size: var(--font-size-base);
  background: var(--color-background-light);
  color: var(--color-text-primary);
  outline: none;
  transition: border-color 0.2s;
}

.custom-select-wrapper .custom-input:focus {
  border-color: var(--color-brand);
  border-style: solid;
}

/* 프로필 이미지 섹션 */
.profile-image-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 20px;
  background: var(--color-background-light);
  border-radius: 16px;
  margin-bottom: 8px;
}

.profile-image-wrapper {
  position: relative;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  cursor: pointer;
  overflow: hidden;
  box-shadow: var(--shadow-md);
}

.profile-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.profile-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-surface);
  color: var(--color-text-secondary);
  font-size: 48px;
}

.profile-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s;
}

.profile-image-wrapper:hover .profile-overlay {
  opacity: 1;
}

.profile-overlay i {
  font-size: 32px;
  color: white;
}

.uploading-indicator {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
}

.uploading-indicator i {
  font-size: 32px;
  color: white;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.profile-actions {
  display: flex;
  gap: 8px;
}

.profile-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border: none;
  border-radius: 8px;
  background: var(--color-brand);
  color: var(--color-text-black);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  cursor: pointer;
  transition: all 0.2s;
}

.profile-btn:hover:not(:disabled) {
  opacity: 0.9;
  transform: translateY(-1px);
}

.profile-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.profile-btn.delete {
  background: var(--color-special-warning);
  color: white;
}

.profile-btn i {
  font-size: 16px;
}


/* 태블릿 (768px ~ 1024px) */
@media (min-width: 601px) and (max-width: 1024px) {
  .dialog > .paper {
    width: 90%;
    max-width: 800px !important;
    height: 90% !important;
    max-height: 90% !important;
    border-radius: 16px !important;
    border: 1px solid var(--color-text-primary) !important;
    padding: 24px !important;
  }

  .dialog > .paper > .content {
    padding-right: 8px;
  }

  /* 기본정보 2컬럼 그리드 */
  .dialog > .paper > .content .double {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }

  /* 병력사항, 접촉이력, 청구 등 리스트 아이템 4컬럼 */
  .dialog > .paper > .content ul.med-his-list li,
  .dialog > .paper > .content ul.consultation-list li,
  .dialog > .paper > .content ul.claims-list li,
  .dialog > .paper > .content ul.event-list li {
    grid-template-columns: repeat(4, 1fr);
  }

  .dialog > .paper > .content ul.med-his-list li .large,
  .dialog > .paper > .content ul.consultation-list li .large,
  .dialog > .paper > .content ul.claims-list li .large,
  .dialog > .paper > .content ul.event-list li .large {
    grid-column: span 4;
  }

  /* 프로필 섹션 가로 배치 */
  .profile-image-section {
    flex-direction: row;
    justify-content: flex-start;
    gap: 24px;
    padding: 24px;
  }

  .profile-image-wrapper {
    width: 100px;
    height: 100px;
    flex-shrink: 0;
  }

  .profile-actions {
    flex-direction: column;
    gap: 8px;
  }

  /* 가족 리스트 */
  .dialog > .paper > .content ul.family-list li {
    padding: 16px;
  }

  /* 수신동의 2컬럼 */
  .agreement-edit-list {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
  }

  .agreement-edit-item:first-child {
    grid-column: span 2;
  }

  /* 버튼 영역 */
  .dialog > .paper > .btns {
    padding-top: 16px;
  }

  .dialog > .paper > .btns > button {
    max-width: 200px;
    height: 44px;
  }

  /* 파일 업로드 영역 */
  .upload-area {
    padding: 40px;
  }

  .dialog > .paper > .content ul.files-edit-list li {
    padding: 16px;
  }
}

/* 모바일 (600px 이하) */
@media (max-width: 600px) {
  #dialog-customerEdit .dialog {
    padding: 0;
  }

  .dialog > .paper {
    width: 100%;
    max-width: 100% !important;
    height: 100vh !important;
    max-height: 100% !important;
    border-radius: 0 !important;
    border: none !important;
    padding: 16px !important;
  }

  .dialog > .paper > .content .double {
    flex-direction: column;
    gap: 16px;
  }

  .dialog > .paper > .content ul.med-his-list li,
  .dialog > .paper > .content ul.consultation-list li,
  .dialog > .paper > .content ul.claims-list li,
  .dialog > .paper > .content ul.event-list li {
    grid-template-columns: 1fr 1fr;
  }

  .dialog > .paper > .content ul.med-his-list li .large,
  .dialog > .paper > .content ul.consultation-list li .large,
  .dialog > .paper > .content ul.claims-list li .large,
  .dialog > .paper > .content ul.event-list li .large {
    grid-column: span 2;
  }

  .profile-image-wrapper {
    width: 100px;
    height: 100px;
  }

  .agreement-edit-list {
    display: flex;
    flex-direction: column;
  }
}
</style>